export default "__VITE_ASSET__BFiFG71J__"